var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-date-picker',{attrs:{"scrollable":"","first-day-of-week":1,"full-width":_vm.fullWidth,"day-format":(date) => new Date(date).getDate()},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }